<template>
    <div class="o-tiles-pagination tiles-pagination">
        <div
            v-touch:swipe="swipeHandler"
            class="tiles-pagination-items"
        >
            <div class="tiles-pagination-container">
                <MTile
                    v-for="item in itemsToShow"
                    :key="item.id"
                    :item="item"
                    :view="view"
                    @click="handleClickTile"
                />
            </div>
        </div>
        <div
            v-if="isControls"
            class="tiles-pagination-controls"
        >
            <button
                type="button"
                class="tiles-pagination-button tiles-pagination-button-up"
                :disabled="disableUp"
                @click="prevPage"
            />
            <span class="tiles-pagination-label">
                {{ pageNumber + 1 }} of {{ pageCount }}
            </span>
            <button
                type="button"
                class="tiles-pagination-button"
                :disabled="disableDown"
                @click="nextPage"
            />
        </div>
    </div>
</template>

<script>
import MTile from '../../molecules/m-tile';
import tilesPagination from "@/utils/mixins/tiles-pagination";
import { EVENTS } from "@/utils/constants/bus-events-constants";

export default {
    name: 'OTilesPagination',
    mixins: [tilesPagination],
    components: {
        MTile
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        view: {
            type: String,
            default: ''
        },
        itemsPerBlock: {
            type: Number,
            default: 24
        }
    },
    computed: {
        isControls() {
            return this.pageCount > 1;
        }
    },
    methods: {
        swipeHandler(direction) {
            switch (direction) {
                case 'top':
                    if (!this.disableDown) this.nextPage();
                    break;
                case 'bottom':
                    if (!this.disableUp) this.prevPage();
                    break;
                default:
                    break;
            }
        },
        handleClickTile(item) {
            if (item.type === 'tenant') {
                this.$bus.$emit(EVENTS.MODALS.INIT_TILES_MODAL, item.id, this.view);
            } else {
                const params = { itemId: item.id };
                this.$bus.$emit(EVENTS.MODALS.INIT_SERVICES_MODAL, params, this.view);
            }
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>